import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { registerServiceWorker } from "./lib/pwa";
import "./styles/globals.css";

const root = document.getElementById("root");
if (!root) throw new Error("no #root");
createRoot(root).render(<React.StrictMode><App /></React.StrictMode>);
registerServiceWorker();
